















































































import { Component, Vue, Watch } from "vue-property-decorator";
import Api from "@/api";

import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import luxonPlugin from "@fullcalendar/luxon";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import resourceTimegridPlugin from "@fullcalendar/resource-timegrid";
import { DateTime } from "luxon";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/de";
import { IFacility, IVenue } from "@/interface";
import { AxiosResponse } from "axios";

let eventGuid = 0;
let todayStr = new Date().toISOString().replace(/T.*$/, ""); // YYYY-MM-DD of today

const INITIAL_EVENTS = [
  {
    id: createEventId(),
    title: "All-day event",
    start: todayStr
  },
  {
    id: createEventId(),
    title: "Timed event",
    start: todayStr + "T12:00:00"
  }
];

function createEventId() {
  return String(eventGuid++);
}

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    FullCalendar, // make the <FullCalendar> tag available
    DatePicker
  }
})
export default class Timetable extends Vue {
  private componentKey = 0;
  private facilities: Array<IFacility> = [];
  private selectedDate = new Date();
  private dateFormat = "DD.MM.YYYY";
  private CalendarApi: any = null;
  private calendarOptions: any = {
    schedulerLicenseKey: "CC-Attribution-NonCommercial-NoDerivatives",
    plugins: [
      dayGridPlugin,
      timeGridPlugin,
      interactionPlugin, // needed for dateClick
      luxonPlugin,
      resourceTimelinePlugin,
      resourceTimegridPlugin
    ],
    headerToolbar: {
      left: "prev today next",
      right: ""
    },
    datesAboveResources: true,
    resourceGroupField: "",
    resources: [],
    height: "auto",
    allDaySlot: false,
    firstDay: 1,
    dayHeaders: true,
    dayHeaderFormat: "EEE d.M",
    datesSet: this.handleChangeDate,
    slotMinTime: "07:00:00",
    slotMaxTime: "23:00:00",
    slotMinWidth: "100",
    slotLabelFormat: "HH",
    slotLabelContent: this.handleSlotLabelContent,
    eventTimeFormat: "HH:mm",
    slotDuration: "01:00",
    initialView: "resourceTimeGridWeek",
    titleFormat: "{{dd.LL}}.yyyy",
    initialEvents: INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
    editable: true,
    droppable: true,
    selectable: true,
    selectMirror: true,
    dayMaxEvents: true,
    weekends: true,
    select: this.handleDateSelect,
    eventClick: this.handleEventClick,
    eventsSet: this.handleEvents,
    eventDragStart: this.handleEventDragStart,
    eventDrop: this.handleEventDrop,
    eventReceive: this.handleEventDrop,
    resourceAreaHeaderContent: "Location",
    weekNumbers: true,
    weekNumberFormat: this.weekNumberFormat
    /* you can update a remote database when these fire:
        eventAdd:
        eventChange:
        eventRemove:
        */
  };
  private currentEvents: Array<any> = [];

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.getFacilities(() => {
        //
      });
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    this.getFacilities(() => {
      //
    });
    next();
  }

  private mounted(): void {
    document
      .getElementsByClassName("fc-toolbar-chunk")[0]
      .prepend(document.getElementById("timetable-selected-date") as any);

    document
      .getElementsByClassName("fc-toolbar-chunk")[0]
      .prepend(document.getElementById("calendar-label") as any);

    this.CalendarApi = (this.$refs.calendar as any).$options.calendar;
  }

  private getFacilities(successCallback?: any): void {
    const endpoint: string = this.$partnerEndpoint("facilities/simplified");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.facilities = response.data.data;
        response.data.data.map((facility: IFacility) => {
          facility.venues &&
            facility.venues.map((venue: IVenue) => {
              this.calendarOptions.resources.push({
                id: venue.id,
                title: `${facility.name} - ${venue.name}`
              });
            });
        });
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  private handleDateSelect(selectInfo: any): void {
    let title = prompt("Please enter a new title for your event");
    let calendarApi = selectInfo.view.calendar;

    calendarApi.unselect(); // clear date selection

    if (title) {
      calendarApi.addEvent({
        id: createEventId(),
        title,
        start: selectInfo.startStr,
        end: selectInfo.endStr,
        allDay: selectInfo.allDay,
        resourceId: selectInfo.resource.id
      });
    }
  }

  private handleEventClick(clickInfo: any): void {
    if (
      confirm(
        `Are you sure you want to delete the event "${clickInfo.event.title}"`
      )
    ) {
      clickInfo.event.remove();
    }
  }

  private handleEvents(events: Array<any>): void {
    this.currentEvents = events;
  }

  private handleEventDragStart(): void {
    this.CalendarApi.setOption("snapDuration", "00:05:00");
  }

  private handleEventDrop(): void {
    this.CalendarApi.setOption("snapDuration", "00:30:00");
  }

  private handleChangeDate(dateInfo: any): void {
    this.selectedDate = dateInfo.start;
  }

  private handleSlotLabelContent(arg: any): void {
    return isNaN(parseInt(arg.text))
      ? arg.text
      : `${arg.text} - ${parseInt(arg.text) < 9 ? "0" : ""}${parseInt(
          arg.text
        ) + 1}`;
  }

  private weekNumberFormat(value: any): string {
    return `KW ${
      DateTime.local(
        value.date.array[0],
        value.date.array[1] + 1,
        value.date.array[2]
      ).weekNumber
    }`;
  }

  @Watch("selectedDate")
  selectedDateChanged(newDate: Date): void {
    newDate && this.CalendarApi.gotoDate(newDate);
  }
}
